import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";

const useResolverBondAmount = () => {
    const web3 = useWeb3();

    const resolverBond = async (address) => {
            const contract = getTrade(address, web3);
            try {
                const resolverBond = await contract.methods.getResolverBondAmount().call();
                return resolverBond;
            } catch (error) {
                console.error("Error fetching resolver bond amount:", error.message || error);
                throw error;
            }
        }

    return { resolverBond };
};

export default useResolverBondAmount;
